<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "MasterView",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
